import { type ComponentPropsWithoutRef } from 'react'

import type { TypePageEntry } from '@contentful-types/page'

import { PageFooter } from '@components/page-footer/page-footer'
import { PageHeader } from '@components/page-header/page-header'
import { SectionRenderer } from '@components/renderer'
import { Column } from '@components/ui-core/column/column'
import { Sprites } from '@components/ui-core/sprite/sprites'

export interface CmsPageBodyProps extends ComponentPropsWithoutRef<'div'> {
  data: TypePageEntry
}

export const CmsPageBody = ({ data, style, ...rest }: CmsPageBodyProps) => {
  const { header, heroSection, sections } = data?.fields || {}

  return (
    <>
      <Sprites />
      <div style={{ ...style }} {...rest}>
        <PageHeader header={header} />
        <Column as="main">
          <SectionRenderer isHero isH1Section data={heroSection} startIndexInPage={0} />
          <SectionRenderer data={sections} startIndexInPage={1} />
        </Column>
        <PageFooter />
      </div>
    </>
  )
}
